<template>
  <v-container fluid class="relative-position">
    <v-card>
      <v-card-title class="py-2">
        <div class="text-center width-100p">
          {{ nombreProp }}
        </div>
      </v-card-title>
      <v-form :class="[fullForm ? 'layout row justify-center pa-3 pt-0' : '']">
        <v-container :class="[fullForm ? 'flex xs12 md11 lg10' : '']">
          <v-layout align-space-between justify-start row fill-height wrap>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3' : 'py-1 xs12 md4']">
              <v-text-field v-model="contacto.Nombre" label="Nombre" class="mt-1" hide-details />
            </v-flex>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3' : 'py-1 xs12 md4']">
              <v-text-field v-model="contacto.Cargo" label="Cargo" class="mt-1" hide-details />
            </v-flex>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3' : 'py-1 xs12 md4']">
              <v-text-field
                v-model="contacto.CorreoElectronico"
                label="Correo Electronico"
                class="mt-1"
                hide-details
              />
            </v-flex>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3' : 'py-1 xs12 md4']">
              <v-text-field
                v-model="contacto.TelefonoTrabajo"
                label="Movil Trabajo"
                class="mt-1"
                hide-details
              />
            </v-flex>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3' : 'py-1 xs12 md4']">
              <v-text-field
                v-model="contacto.TelefonoParticular"
                label="Movil Particular"
                class="mt-1"
                hide-details
              />
            </v-flex>
            <v-flex :class="[fullForm ? 'py-1 xs12 sm6 md4 lg3' : 'py-1 xs12 md4']">
              <v-text-field v-model="contacto.Fax" label="Fax" class="mt-1" hide-details />
            </v-flex>
          </v-layout>
          <v-layout align-space-between justify-start row fill-height wrap>
            <v-flex :class="[fullForm ? 'py-1 xs12' : 'py-1 xs12']">
              <v-textarea
                v-model="contacto.Observaciones"
                :max-height="25"
                :hide-details="!fullForm"
                rows="2"
                label="Observaciones"
                class="mt-0"
              />
            </v-flex>
          </v-layout>
          <v-menu
            open-on-hover
            top
            nudge-top="34"
            transition="fade-transition"
            content-class="elevation-0"
          >
            <template v-slot:activator="{ on }">
              <v-btn class="mt-3" color="success" v-on="on" @click="modify()">
                <v-icon class="mr-2">
                  mdi-content-save
</v-icon>Guardar
              </v-btn>
            </template>
            <v-list class="small-list success py-0" dark>
              <v-list-tile @click="modify('exit')">
                Guardar sin salir
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'ContactoEdit',
  props: {
    fullForm: { type: Boolean, default: true },
    nombreProp: { type: [String, Number], default: '' },
    cargoProp: { type: [String, Number], default: '' },
    emailProp: { type: [String, Number], default: '' },
    movilTrabajoProp: { type: [String, Number], default: '' },
    movilParticularProp: { type: [String, Number], default: '' },
    faxProp: { type: [String, Number], default: '' },
    observacionesProp: { type: [String, Number], default: '' },
    instalacionProp: { type: [String, Number], default: '' },
    clienteProp: { type: [String, Number], default: '' },
    numOrdenProp: { type: [String, Number], default: '' }
  },
  data () {
    return {
      contacto: [],
      cont: {}
    }
  },
  mounted () {
    if (this.nombreProp !== 'new') {
      this.cargaContacto(this.instalacionProp, this.clienteProp, this.numOrdenProp)
    }
  },
  methods: {
    cargaContacto (instalacion, cliente, numOrden) {
      this.axios
        .get(
          `${this.$apiUrl(
            'getPersonaContacto'
          )}?cliente=${cliente}&instalacion=${instalacion}&numeroOrden=${numOrden}`,
          { headers: { 'Content-Type': 'application/json' } }
        )
        .then(({ data }) => {
          this.contacto = data
        })
    },
    modify (postAction) {
      if (this.nombreProp !== 'new') {
        this.axios
          .put(
            `${this.$apiUrl('personaContacto')}?id=${
              this.contacto.NumeroOrden
            }&instalacionpersonacontacto=${this.contacto}`,
            this.contacto,
            { headers: { 'Content-Type': 'application/json' } }
          )
          .then(response => {
            if (response.status === 204) {
              this.$notify({ message: 'Contacto actualizado correctamente' })
            }
          })
      } else {
        this.cont.Nombre = this.contacto.Nombre
        this.cont.Cargo = this.contacto.Cargo
        this.cont.CorreoElectronico = this.contacto.CorreoElectronico
        this.cont.TelefonoTrabajo = this.contacto.TelefonoTrabajo
        this.cont.TelefonoParticular = this.contacto.TelefonoParticular
        this.cont.Nombre = this.contacto.Nombre
        this.cont.Fax = this.contacto.Fax
        this.cont.Observaciones = this.contacto.Observaciones
        this.cont.Cliente = this.clienteProp
        this.cont.Instalacion = this.instalacionProp

        this.axios
          .post(
            `${this.$apiUrl('postPersonaContacto')}?instalacionpersonacontacto=${this.cont}`,
            this.cont,
            { headers: { 'Content-Type': 'application/json' } }
          )
          .then(response => {
            if (response.status === 201) {
              this.$notify({ message: 'Contacto creado correctamente' })
              if (this.postAction({ action: postAction, toName: 'clientes' })) {
                this.$router.push({
                  name: 'ClientesEdit',
                  params: {
                    clienteProp: response.data.Cliente,
                    instalacionProp: response.data.Instalacion
                  }
                })
              } else {
                this.loadInstalacion(response.data.Cliente, response.data.Instalacion)
              }
            }
          })
      }
    }
  }
}
</script>
